import request from "../util/request.js"
export default async function (e) {
    const { data } = await request({
        method: "get",
        params: e
    })
    return data
}

 